

















import mixin from './cardmixin.vue'
import Vue from 'vue'
import { ProductionCardServiceProxy } from '@/service-proxies/app-v2/coproduction.service-proxies'
const pcsp = new ProductionCardServiceProxy()

export default Vue.extend({
  name: 'employee-performance-table',
  mixins: [mixin],
  data() {
    return {
      columns: [
        {
          title: this.$t('page_employee_code'),
          dataIndex: 'producerCode'
          // width: "160px",
        },
        {
          title: this.$t('page_employee_name'),
          dataIndex: 'producerName'
          // width: "100px",
        },
        {
          title: this.$t('page_plan_product_no'),
          dataIndex: 'productCode'
          // width: "100px",
        },
        {
          title: this.$t('page_process_name'),
          dataIndex: 'processName'
          // width: "200px",
        },
        {
          title: this.$t('page_process_code'),
          dataIndex: 'processCode'
        },
        {
          title: this.$t('page_control_rate') + '(%)',
          dataIndex: 'qualifyRate'
        }
      ],
      data: []
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    async getList() {
      const data = await pcsp.employeePerformanceCardList()
      this.data = data.map((item) => ({
        ...item,
        qualifyRate: parseInt(item.qualifyRate)
      }))
      this.checkScrollY('employee-performance', this.data.length)
    }
  }
})
